
import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "NotificationsTaskTemplate",

  components: {
    NotificationsTag: () => import("@/modules/Notifications/components/NotificationsTag.vue"),
    NotificationsDate: () => import("@/modules/Notifications/components/NotificationsDate.vue"),
  },

  props: {
    status: {
      type: String as () => "" | "due_soon" | "overdue" | "platform" | "home_office",
      default: "overdue",
    },
    date: {
      type: String,
      default: "DD/MM/YYYY",
    },
    title: {
      type: String,
      default:
        "Upload the document stating that  Lora Molohoph,jb,klkjlh was on student vacation while working full-time",
    },
  },

  emits: ["click"],

  setup(props, { emit }) {
    function onClick() {
      emit("click");
    }

    return {
      onClick,
    };
  },
});
